import { parseToDate } from "./dateUtils";

export const formatDutchDate = (value, fallback = "—") => {
  const date = parseToDate(value);
  if (!date) return fallback;

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${day}-${month}-${date.getFullYear()}`;
};
